import axios from 'axios';
import Cookies from 'js-cookie';

// Robust configuration that handles both dev and prod environments
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 15 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Cookies.remove('auth_token');
    }
    return Promise.reject(error);
  }
);

// --- LIVE PAYMENT API ---
export const paymentAPI = {
  createPaymentIntent: async (paymentData) => {
    console.log("Initiating REAL payment intent:", paymentData);
    try {
      const response = await api.post('/create-payment-intent', paymentData);
      return response.data;
    } catch (error) {
      console.error("Payment API Error:", error.message);
      // NO MOCK FALLBACK HERE. If server is down, payment fails.
      throw new Error("Kunne ikke koble til betalingsserveren. Sjekk at server.js kjører.");
    }
  }
};

// ... Rest of the exports
export const authAPI = {
  login: async (email, password) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    const token = 'live-token-' + Date.now();
    Cookies.set('auth_token', token, { expires: 7 });
    return { token, user: { email, name: 'Bruker' } };
  },
  logout: async () => Cookies.remove('auth_token'),
  register: async (userData) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return { success: true };
  },
  validateToken: async () => ({ valid: true }),
  resetPassword: async (email) => ({ success: true })
};

// Keep other APIs as they are (Supabase/Local state handled in Context)
export const companyAPI = { getCompanies: async () => [], createCompany: async (data) => ({ id: 'comp_' + Date.now(), ...data }), updateCompany: async () => ({ success: true }) };
export const reportsAPI = { getReports: async () => [], createReport: async (data) => ({ id: 'rep_' + Date.now(), ...data }), updateReport: async () => ({ success: true }) };
export const fileAPI = { uploadFile: async (file) => ({ url: URL.createObjectURL(file), name: file.name }), deleteFile: async () => ({ success: true }) };

export default api;